import Page from 'src/components/Page'
import Footer from './Footer'
import Header from './Header'
import { Container } from '@mui/material'
import { styled } from "@mui/system";
import Chatbot from './Chatbot';

const RootStyle = styled('div')(({ theme }) => ({
	background: 'linear-gradient(135deg, #D0AC37, #FF6B00)',
	minHeight: '100vh',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	padding: theme.spacing(3),
	[theme.breakpoints.up('md')]: {
	  padding: theme.spacing(5),
	  flexDirection: 'row',
	},
	[theme.breakpoints.down('sm')]: {
	  flexDirection: 'column',
	},
  }))

  export default function HomeLayout({ children }) {
	return (
		<Page title="Accueil">
			<Header />
			
			<RootStyle>
				<Container
					disableGutters
					maxWidth={false} // Désactive le maxWidth par défaut
					component="main"
					sx={{
						minHeight: '90vh',
						margin: 0,
						width: '100%',
						pt: 20, // Ajoute de l'espace en haut du Container (paddingTop)
					}}
				>
					
					{children}
				</Container>
			</RootStyle>
			<Footer />
		</Page>
	)
}